import React from "react";
import Layout from "../../components/Layout";

const Compliance = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow">
                        <span className="dot"></span> Compliance
                    </div>
                    <h1>Anti-Money Laundering and Counter Terrorist Financing Policy</h1>
                    <p className="small-muted">Last updated on 30 December 2021</p>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container" style={{ maxWidth: 820 }}>
                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>Introduction</h2>
                        <p>
                            Everest Network Ltd (the Company) and its board of directors is committed to full compliance with all
                            applicable laws and regulations regarding money laundering and the financing of terrorism. Every officer,
                            director, employee and associated person of the Company is responsible for assisting in the Company’s
                            efforts to detect, deter and prevent money laundering and other activities intended to facilitate the funding
                            of terrorism or criminal activities through its services.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>Obligations</h2>
                        <p>
                            The principle requirements, obligations and penalties, on which the Company’s systems and controls are
                            based, derive from the European Union Anti Money Laundering Directives which have been transposed in
                            Malta’s legislation within the Prevention of Money Laundering Act (Cap.373) (the PMLA) and the Prevention of
                            Money Laundering and Funding of Terrorism Regulations (Cap.373.01) (the PMLFTR). The Company’s obligations
                            also emanate from the Virtual Financial Assets Act (Cap.590) (the VFAA). The Company has instituted measures
                            in order to:
                        </p>
                        <ul className="check-list micro-list">
                            <li>comply with rules and regulations regarding customer identification, monitoring and recordkeeping;</li>
                            <li>detect and analyse suspicious activity and if required report such activity; and</li>
                            <li>develop, update and execute internal policies, procedures and controls.</li>
                        </ul>
                        <p style={{ marginTop: 14 }}>
                            Apart from the above measures the Company has set up internal procedures concerning the following basic
                            principles:
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>Sanction lists</h2>
                        <p>
                            National authorities and supranational organizations (such as UN, EU and OFAC) impose restrictive measures
                            against countries, organizations, groups, entities, and individuals. In this respect the Company screens
                            its customers against such sanction lists taking the necessary action should a prospective or current
                            customer be identified.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>Risk Assessment</h2>
                        <p>
                            In determining the level of Customer Due Diligence the Company identifies and assesses the ML/TF risk in
                            relation to a customer or particular transaction. Assessing and understanding client-related money laundering
                            and terrorist financing risks is a critical component of our AFC Risk Management framework, which helps us
                            to mitigate and manage risk in line with our financial crime risk appetite. The primary objective of risk
                            segmenting our client base is to conduct appropriate due diligence and to ensure a comprehensive client
                            profile is in place to enable the comparison of the results of ongoing monitoring and identify any
                            discrepancies.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>Customer On Boarding</h2>
                        <p>
                            The extent and timing in carrying out Customer Due Diligence measures is applied to the customer depending
                            on the outcome of the customer risk assessment. Certainly, the Company, will identify and verify the customer
                            using reliable independent source documents as permitted by the Regulations. Verification of the customer’s
                            identification, which will be produced via government-issued documents containing a photographic image, will
                            mainly be carried out utilising video conferencing tools, identity verification software or using recognised
                            commercial electronic data providers or E-IDs. In addition to the identity details to be collected and
                            verified, the Company, is also required to verify the wallet address/account number to ensure that the
                            wallet actually belongs to the customer.
                        </p>
                        <p style={{ marginTop: 14 }}>
                            Further to the above, the Company, will obtain, in accordance with the Regulations, details as to the purpose
                            and intended nature of the business relationship as well as to determine the customer’s source of wealth and
                            source of funds. In any instance, the Company, will not enter into a business relationship or carry out an
                            occasional transaction unless it has verified the true identity of the customer and its beneficial owners
                            where applicable.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>Training</h2>
                        <p>
                            The training of employees plays a vital role in the effectiveness of the Company’s ongoing monitoring
                            systems. We deliver training to help employees understand regulation, compliance, fraud awareness,
                            corruption and sanctions.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>Cooperation with Government Bodies</h2>
                        <p>
                            The Company is committed to the fight against money laundering and the financing of terrorism. As such, the
                            Company will cooperate with requests emanating from an authorised Competent Authority as defined within the
                            Regulations.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>Policy updates</h2>
                        <p>
                            This document is not static and could be amended according to changing regulatory obligations or in
                            accordance with the Company’s risk appetite.
                        </p>
                    </article>
                </div>
            </section>
        </Layout>
    );
};

export default Compliance;
